<template>
  <div class="adv-quantity-picker-container" :class="{ 'mounted': isMounted }">
    <div class="adv-quantity-picker-base">
      <span class="adv-quantity-picker-base-remove">
        <button
          :class="[
            buttonCssComputed,
            'adv-quantity-picker-base-remove-button'
          ]"
          type="button"
          v-on:click="buttonRemove"
          :disabled="buttonRemoveDisabled"
          :aria-label="localQuantity <= min ? 'Minimum quantity reached' : 'Remove product'"
        >
            <slot name="minus"><i class="lni lni-minus"></i></slot>
        </button>
      </span>
      <input
        type="text"
        class="adv-quantity-picker-base-input"
        aria-label="Products No"
        :disabled="true"
        v-model.number="localQuantity"
        v-on:change="checkQuantity"
      >
      <span class="adv-quantity-picker-base-add">
        <button
          :class="[
            buttonCssComputed,
            'adv-quantity-picker-base-add-button'
          ]"
          type="button"
          v-on:click="buttonAdd"
          :disabled="buttonAddDisabled"
          :aria-label="localQuantity <= min ? 'Minimum quantity reached' : 'Remove product'"
        >
            <slot name="plus"><i class="lni lni-plus"></i></slot>
        </button>
      </span>
    </div>
  </div>
</template>

<script>
import productMixin from './mixins/productMixins'

export default {
  name: 'AdvQuantityPickerBase',
  mixins: [productMixin],
  props: {
    buttonCss: {
      type: String
    },
    quantity: {
      type: Number,
      default: 0
    },
    productId: {
      type: Number,
      default: null
    },
    productCodeId: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localQuantity: this.quantity,
      isMounted: false
    }
  },
  mounted () {
    setTimeout(() => {
      this.isMounted = true
    }, 500)
  },
  watch: {
    productCodeId () {
      this.localQuantity = this.productCodeData.productStock > 0 ? this.quantity : 0
    },
    quantity (val) {
      this.localQuantity = val
    }
  },
  computed: {
    min () {
      return this.productCodeData.productStock > 0 ? 1 : 0
    },
    max () {
      return this.productCodeData.productStock
    },
    buttonCssComputed () {
      return this.buttonCss
    },
    buttonRemoveDisabled () {
      return this.disabled
    },
    buttonAddDisabled () {
      if (this.disabled) {
        return true
      }
      return this.localQuantity >= this.max
    }
  },
  methods: {
    checkQuantity () {
      if (this.localQuantity < this.min) {
        this.localQuantity = this.min
      }

      if (this.localQuantity > this.max) {
        this.localQuantity = this.max
      }

      this.emitQuantity()
    },
    buttonRemove () {
      if (this.localQuantity === 1) {
        this.$emit('remove-from-cart')
        this.localQuantity = 0
        return
      }
      this.localQuantity -= 1
      this.checkQuantity()
    },
    buttonAdd () {
      this.localQuantity += 1
      this.checkQuantity()
    },
    emitQuantity () {
      this.$emit('quantity-changed', this.localQuantity)
    },
  }
}
</script>

<style lang="scss" scoped>
.adv-quantity-picker-container {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 500ms ease-in-out;
}
.adv-quantity-picker-base {
  position: relative;
  width: 100%;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 3fr 1fr;
  border: 1px solid #3F4444;
  border-radius: 6px;
  height: 64px;
}
.adv-quantity-picker-base-remove, .adv-quantity-picker-base-add {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: var(--white);
  border: unset;
}
.adv-quantity-picker-base-add, .adv-quantity-picker-base-add-button {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.adv-quantity-picker-base-remove, .adv-quantity-picker-base-remove-button {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.adv-quantity-picker-base-remove-button, .adv-quantity-picker-base-add-button {
  padding: 5px;
  width: 100%;
  height: 100%;
  background-color: var(--white);
  border: unset;
  i {
    color: #040403;
  }
}
.adv-quantity-picker-base-input {
  background-color: var(--white);
  text-align: center;
  width: 100%;
  height: 52.5px;
  box-shadow: none;
  transition: all 500ms ease-in-out;
  padding: 0 5px;
  color: #040403;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.5;
  border: unset;
  &:focus {
    outline: none;
  }
}
.adv-quantity-picker-icon {
  display: flex;
  position: relative;
  background-color: #1887AA;
  width: 65px;
  border-radius: 10px;
  svg {
    padding: 7.5px;
  }
}
.adv-quantity-picker-icon-check {
  position: absolute;
  display: grid;
  justify-items: center;
  align-items: center;
  justify-content: center;
  align-content: center;
  border-radius: 50%;
  text-align: center;
  right: 5px;
  top: 5px;
  width: 17px;
  height: 17px;
  background-color: #1B262C;
  color: #FFFFFF;
  line-height: 34px;
  font-size: 20px;
  font-weight: 700;
  .ti-check {
    font-size: 14px;
  }
}

.icon-slide-enter-active {
  transition: all 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.icon-slide-enter {
  /* Set initial width to 0 and move from the left */
  width: 0;
}

.icon-slide-leave-active {
  /* Set a longer transition time for icon slide-out */
  transition: all 1s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.icon-slide-leave-to {
  /* Set width to 0 when the icon slides out */
  width: 0;
}
</style>
